import { NotificationItemData, NotificationQueryItem } from '../../types';
import { routes } from '../../../../routes';
import { t } from 'i18next';

const i18prefix = 'notifications.tickets';
export const mapTicketSubmittedNotificationRenderInfo = (
  src: NotificationQueryItem,
): NotificationItemData | null => {
  const data: NotificationItemData = {
    comment: '',
    urlLabel: '',
    url: '',
    description: '',
  };

  if (src.renderInfo.__typename === 'TicketSubmittedNotificationRenderInfo') {
    if (!src.renderInfo.ticket?.Id) {
      return null;
    }

    const requestId = src.renderInfo.ticket?.Id;
    if (requestId) {
      data.url = routes.tickets.route.create({
        id: requestId,
      });
    }
    data.title = t(`${i18prefix}.submitted`);
    data.icon = 'help-desk-outline';

    const ticket = src.renderInfo.ticket;
    const subject = ticket?.subject;
    if (subject && subject.label) {
      data.urlLabel = subject.label;
    }
  }
  return data;
};
